import { useQuery } from '@tanstack/react-query';
import { APITypes, MedicalDataTypes } from '../../primary-record-types';
import { getRelatedResourcesSuggestionsCacheKey } from './cacheKeys';
import { appAPI } from '../../utils/api';
import urls from '../../utils/urls';
import { useQueryNotify } from '../useQueryCallbacks';
import { getIntl } from '../../utils/intl';

const intl = getIntl('useRelatedResourceSuggestions', {
    errorGettingRelatedResourceSuggestions: 'Error getting related resource suggestions',
});

export type UseRelatedResourceSuggestionsArgs = {
    profileId: string;
    category: MedicalDataTypes.PrimaryRecordResourceCategory;
    resourceId: string;
    relatedCategory: MedicalDataTypes.PrimaryRecordResourceCategory;
};

export type UseRelatedResourceSuggestionsResult = {
    isLoading: boolean;
    suggestions: APITypes.medicalDataService.GetRelatedResourceSuggestionsResponse | null;
};

export default function useRelatedResourceSuggestions({
    profileId,
    category,
    resourceId,
    relatedCategory,
}: UseRelatedResourceSuggestionsArgs): UseRelatedResourceSuggestionsResult {
    const query = useQuery({
        queryKey: getRelatedResourcesSuggestionsCacheKey(profileId, category, resourceId),
        queryFn: async () => {
            return appAPI.get<APITypes.medicalDataService.GetRelatedResourceSuggestionsResponse>(
                urls.api.medicalData.relatedResourceSuggestions(profileId, category, resourceId, relatedCategory),
            );
        },
    });

    useQueryNotify({
        query,
        errorMessage: intl('errorGettingRelatedResourceSuggestions'),
    });

    return {
        isLoading: query.isFetching,
        suggestions: query.data || null,
    };
}
